import { observer } from 'mobx-react-lite'
import { useAddNumbersContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/context/addNumbersContext'
import { HowAddNumberCards } from 'pages/settings/ui/HowAddInboxNumberCards/HowAddNumberCards'

export const HowAddNumber = observer(() => {
  const {
    setAddNumberType,
    nextClickHandler,
    unassignedNumbersCount,
    isGracePeriod,
    shouldHideAddNumbersFlow,
  } = useAddNumbersContext()

  return (
    <HowAddNumberCards
      setAddNumberType={setAddNumberType}
      nextClickHandler={nextClickHandler}
      unassignedNumbersCount={unassignedNumbersCount}
      isGracePeriod={isGracePeriod}
      hiddenKeys={shouldHideAddNumbersFlow ? ['buy', 'app', 'landline'] : []}
    />
  )
})
